export const SHOW_CONTACT_FORM = 'SHOW_CONTACT_FORM';

export const SET_PLACES = 'SET_PLACES';

export const SET_CURRENT_PLACE = 'SET_CURRENT_PLACE';

export const SET_CATEGORIES = 'SET_CATEGORIES';

export const SET_BRANDS = 'SET_BRANDS';

export const SET_CURRENT_CATEGORY_ID = 'SET_CURRENT_CATEGORY_ID';

export const SET_HOVERED_STUDIO_INTERNAL_NAME = 'SET_HOVERED_STUDIO_INTERNAL_NAME';



// WEBPACK FOOTER //
// ./src/redux/actions.js